
import { useQuery } from '@maui/react-query'
import { useMatiApiClient } from './client'

export const useFileUploadQuotaQuery = (options = {}) => {
  const api = useMatiApiClient('vtPrivateScanning')

  return useQuery({
    queryKey: ['fileUploadQuota'],
    queryFn: api.getFileUploadQuota,
    refetchOnWindowFocus: false,
    ...options,
  })
}

export const useUsersListQuery = (options = {}) => {
  const api = useMatiApiClient('vtPrivateScanning')

  return useQuery({
    queryKey: ['vtUsers'],
    queryFn: api.getUsers,
    staleTime: Infinity,
    ...options
  })
}
